class CollapsibleText extends HTMLElement {
  constructor() {
    super();

    this._toggleBtn = this.querySelector(".js-text-toggle");
    this._content = this.querySelector(".js-text-content");
    this.originalContent = this._content.textContent;

    if (this.ellipsisType === "lines") {
      const lines = this.dataset.lines || 3;
      this.style.setProperty("--line-ellipsis", lines);
      this.classList.add("text-elipsis");
    }
  }

  connectedCallback() {
    this._toggleBtn.addEventListener("click", this._toggleCollapse.bind(this));

    const ellipsisType = this.dataset.ellipsisType;
    const characters = parseInt(this.dataset.characters, 10);

    // Handle initial display
    if (ellipsisType === "characters" && characters) {
      const originalContentLength = this.originalContent.trim().length;
      if (originalContentLength <= characters) {
        this._toggleBtn.style.display = "none";
        this.expanded = true;
      } else {
        this._truncateByCharacters(characters);
      }
    } else {
      const clampedHeight = this._getContentClampedHeight();
      this._toggleCollapse();
      const fullHeight = this._content.offsetHeight;
      this._toggleCollapse();

      if (fullHeight <= clampedHeight) {
        this._toggleBtn.style.display = "none";
        this.expanded = true;
      } else {
        this._toggleBtn.style.display = "block";
      }
    }
  }

  _truncateByCharacters(characters) {
    if (this.originalContent.length > characters) {
      this._content.textContent = this.originalContent.slice(0, characters) + "...";
      this.expanded = false;
    } else {
      this.expanded = true;
    }
  }

  _toggleCollapse() {
    this.expanded = !this.expanded;
    const ellipsisType = this.dataset.ellipsisType;
    const characters = parseInt(this.dataset.characters, 10);

    if (ellipsisType === "characters" && characters) {
      if (this.expanded) {
        this._content.textContent = this.originalContent;
      } else {
        this._truncateByCharacters(characters);
      }
    } else {
      this._content.style.maxHeight = this.expanded
        ? "none"
        : `${this._getContentClampedHeight()}px`;
    }
  }

  _getContentClampedHeight() {
    const lineHeight = parseFloat(window.getComputedStyle(this._content).lineHeight);
    return lineHeight * this.lineCount;
  }

  get expanded() {
    return this.getAttribute("aria-expanded") === "true";
  }

  set expanded(value) {
    this.setAttribute("aria-expanded", value);
  }

  get lineCount() {
    return getComputedStyle(this).getPropertyValue("--line-ellipsis");
  }

  get ellipsisType() {
    return this.dataset.ellipsisType;
  }
}

window.customElements.define("collapsible-text", CollapsibleText);
